import React from 'react';
import {FormikHelpers} from "formik";
import {useOperator} from "context/OperatorContext";
import Form, {
  ColourField,
  FormBlock,
  FormSection,
  SelectField,
  TextAreaField,
  TextField
} from 'components/Form/Form';
import {Option} from "components/Form/Form/Control";
import IconName from "../../../types/IconName";
import {toTitleCase} from "../../../services/string";
import * as Yup from "yup";
import {QuizType, QuizTypeData} from "../../../types/QuizType";

// Types ----

type QuizTypeFormProps = {
  quizType?: QuizType | null
  onSubmit: (values: QuizTypeData, helpers: FormikHelpers<QuizTypeData>) => any
}

// Helpers ----

const iconOptions: Array<Option> = Object.values(IconName).map(icon => ({
  id: icon, name: toTitleCase(icon), icon: icon
}))

// Component ----

function QuizTypeForm({quizType, onSubmit}: QuizTypeFormProps) {
  const {termFor} = useOperator()

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("This field is required").max(250, "Maximum character limit exceeded"),
  })

  const initialValues: QuizTypeData = {
    name: quizType?.name ?? '',
    colour: quizType?.colour ?? '#2b2d30',
  }

  return (
    <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      <FormSection
        name='Key Information'
        description={`Basic details about the ${termFor('quiz type')}`}
        columns={6}
      >

        {/* Name */}
        <FormBlock columns={3}>
          <TextField
            name="name"
            label="Name *"
            hint="250 chars max"
            help="The publicly visible display name"
            autoComplete="off"
            maxLength={250}
            autoFocus
          />
        </FormBlock>

        {/* Colour */}
        <div className='col-start-1'>
          <FormBlock columns={1}>
              <ColourField
                name="colour"
                label="Colour *"
                autoComplete="off"
              />
          </FormBlock>
        </div>
      </FormSection>
    </Form>
  );
}

export default QuizTypeForm;